import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Herndon Cannabis News</p>
        <h1>Your Source for Cannabis Policy and Culture</h1>
        <p className="lede">
          Stay informed with the latest updates on cannabis laws, policies, and cultural developments in Herndon. 
          Our platform provides comprehensive coverage and educational resources to help you navigate the evolving landscape of cannabis.
        </p>
        <div className="cta-row">
          <a href="/latest-updates" target="_self">
            Read the Latest Updates
          </a>
          <a href="/educational-resources" target="_self" className="secondary">
            Explore Educational Resources
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Local Law Updates</h2>
          <p>
            Keep up with the latest changes in cannabis legislation and local policies affecting the community.
          </p>
        </article>
        <article>
          <h2>Understanding Legal Status</h2>
          <p>
            Get clear information about the legal status of cannabis in Herndon and what it means for residents.
          </p>
        </article>
        <article>
          <h2>Cannabis Culture Insights</h2>
          <p>
            Discover articles and features that delve into the cultural aspects of cannabis and its impact on our community.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;